module.exports = __webpack_public_path__ + "static/media/shape1_6.2e72467a.obj";